export default "__VITE_ASSET__CehHBmw6__"